import { Controller } from '@hotwired/stimulus';
import { Foundation } from 'foundation-sites';

export default class PoolFormController extends Controller {
    static targets = ['form', 'inlineChange'];

    connect () {
        console.log('PoolFormController.connect');

        this.#setInlineChange(false);
    }

    #setInlineChange (newVal) {
        console.log('setting inline change = ' + newVal);
        this.inlineChangeTarget.value = newVal;
    }

    submit (evt) {
        evt.preventDefault();
        console.log('submitting form for new config ...');
        this.#setInlineChange('true');
        this.formTarget.requestSubmit();
        this.#setInlineChange('false');
    }
}